import { render, staticRenderFns } from "./ItemCustomColor.vue?vue&type=template&id=270cc30e&scoped=true&"
import script from "./ItemCustomColor.vue?vue&type=script&lang=ts&"
export * from "./ItemCustomColor.vue?vue&type=script&lang=ts&"
import style0 from "./ItemCustomColor.vue?vue&type=style&index=0&id=270cc30e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270cc30e",
  null
  
)

export default component.exports